import { create } from "zustand";

interface UIState {
  sidebarOpen: boolean;
  registerRiderOpen: boolean;
  selectedShipmentId: string | null;
  selectedRiderId: string | null;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
  setRegisterRiderOpen: (open: boolean) => void;
  setSelectedShipmentId: (id: string | null) => void;
  setSelectedRiderId: (id: string | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarOpen: true,
  registerRiderOpen: false,
  selectedShipmentId: null,
  selectedRiderId: null,
  setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setRegisterRiderOpen: (registerRiderOpen) => set({ registerRiderOpen }),
  setSelectedShipmentId: (selectedShipmentId) => set({ selectedShipmentId }),
  setSelectedRiderId: (selectedRiderId) => set({ selectedRiderId }),
}));
